/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Months_UnitInputs */

const en_admin_discounts_months_unit = /** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`months`)
};

const de_admin_discounts_months_unit = /** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monate`)
};

const es_admin_discounts_months_unit = /** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meses`)
};

const fr_admin_discounts_months_unit = /** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois`)
};

const nl_admin_discounts_months_unit = /** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`maanden`)
};

/** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */
const it_admin_discounts_months_unit = en_admin_discounts_months_unit;

/** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */
const pt_br2_admin_discounts_months_unit = en_admin_discounts_months_unit;

/** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */
const pl_admin_discounts_months_unit = en_admin_discounts_months_unit;

/** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */
const hu_admin_discounts_months_unit = en_admin_discounts_months_unit;

/** @type {(inputs: Admin_Discounts_Months_UnitInputs) => LocalizedString} */
const ro_admin_discounts_months_unit = en_admin_discounts_months_unit;

/**
* | output |
* | --- |
* | "months" |
*
* @param {Admin_Discounts_Months_UnitInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_months_unit = /** @type {((inputs?: Admin_Discounts_Months_UnitInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Months_UnitInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_months_unit(inputs)
	if (locale === "de") return de_admin_discounts_months_unit(inputs)
	if (locale === "es") return es_admin_discounts_months_unit(inputs)
	if (locale === "fr") return fr_admin_discounts_months_unit(inputs)
	if (locale === "nl") return nl_admin_discounts_months_unit(inputs)
	if (locale === "it") return it_admin_discounts_months_unit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_months_unit(inputs)
	if (locale === "pl") return pl_admin_discounts_months_unit(inputs)
	if (locale === "hu") return hu_admin_discounts_months_unit(inputs)
	return ro_admin_discounts_months_unit(inputs)
});
export { admin_discounts_months_unit as "admin.discounts.months_unit" }